// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 75px;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__linkBtn {
  border: 1px solid black;
  border-radius: 4px;
  padding: 0 11px;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
  color: var(--colors-greyDark);
  display: flex;
  align-items: center;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__linkBtn:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__saveBtn {
  display: flex;
  align-items: center;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__settings {
  display: flex;
  align-items: center;
}
.app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__toggleBtn {
  width: 100px !important;
  border: none !important;
  font-size: 14px !important;
  text-transform: initial !important;
  font-weight: bold !important;
  color: var(--colors-greyDark) !important;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/DashboardHeader/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AAKrB;;AAHE;IACE,qCAAqC;EACvC;;AAGF;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAIA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,wCAAwC;AAC1C","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 75px;\n}\n\n.linkBtn {\n  border: 1px solid black;\n  border-radius: 4px;\n  padding: 0 11px;\n  height: 30px;\n  font-size: 14px;\n  font-weight: bold;\n  color: var(--colors-greyDark);\n  display: flex;\n  align-items: center;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n}\n\n.saveBtn {\n  display: flex;\n  align-items: center;\n}\n\n.settings {\n  display: flex;\n  align-items: center;\n}\n\n// TO DO : implement injection order for mui https://mui.com/material-ui/integrations/interoperability/#css-injection-order\n//  but it seems to override the css variables, so we cant use, for ex., color: var(--colors-greyDark) below\n.toggleBtn {\n  width: 100px !important;\n  border: none !important;\n  font-size: 14px !important;\n  text-transform: initial !important;\n  font-weight: bold !important;\n  color: var(--colors-greyDark) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__container`,
	"linkBtn": `app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__linkBtn`,
	"saveBtn": `app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__saveBtn`,
	"settings": `app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__settings`,
	"toggleBtn": `app-pages-Project-ProductionManagement-Dashboards-DashboardHeader-___styles__toggleBtn`
};
export default ___CSS_LOADER_EXPORT___;
